import { publish, publishSticky, subscribe } from '@wh/message-bus';

export const WH_RADIO_PLAY_REQUESTED = 'mediaplayers.whradio.play';
export const WH_RADIO_PAUSE_REQUESTED = 'mediaplayers.whradio.stop';
export const WH_RADIO_MUTE_REQUESTED = 'mediaplayers.whradio.mute';
export const WH_RADIO_UNMUTE_REQUESTED = 'mediaplayers.whradio.unmute';

export const RADIO_STATE_UPDATED = 'wh.sports.event.radio.state.updated';
export const RADIO_MUTE_TOGGLE = 'wh.sports.event.radio.mute.toggle';
export const RADIO_PLAY_CLICKED = 'wh.sports.event.radio.play.clicked';
export const RADIO_PAUSE_CLICKED = 'wh.sports.event.radio.pause.clicked';
export const RADIO_MARQUEE_ANIMATION_START = 'wh.sports.event.radio.marquee-animation.start';

export const muteRadio = () => {
  publish({ topic: WH_RADIO_MUTE_REQUESTED });
};

export const pauseRadio = () => {
  publish({ topic: WH_RADIO_PAUSE_REQUESTED });
};

export const playRadio = (id) => {
  publish({ topic: WH_RADIO_PLAY_REQUESTED, data: id });
};

export const unmuteRadio = () => {
  publish({ topic: WH_RADIO_UNMUTE_REQUESTED });
};

export const radioMarqueeAnimationSubscribe = (callback) => {
  subscribe({
    topic: RADIO_MARQUEE_ANIMATION_START,
    callback,
  });
};

export const radioPauseSubscribe = (callback) => {
  subscribe({
    topic: RADIO_PAUSE_CLICKED,
    callback,
  });
};

export const radioPlaySubscribe = (callback) => {
  subscribe({
    topic: RADIO_PLAY_CLICKED,
    callback,
  });
};

export const radioMuteToggleSubscribe = (callback) => {
  subscribe({
    topic: RADIO_MUTE_TOGGLE,
    callback,
  });
};

export const publishRadioState = (data) => {
  publishSticky(RADIO_STATE_UPDATED, data);
};
